/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";

import HeaderTitle from "../includes/HeaderTitle";
import Paging from "../includes/Paging";
import SuggestionSearch from "./SuggestionSearch";
import SuggestionSearchResult from "./SuggestionSearchResult";

import {isNull} from "../../../components/common/Common";

function SuggestionList({setMenuItem}) {
  //검색 정보 저장 변수
  const [varSearchData, setSearchData] = useState({
    sdate:null,
    edate:null,
    searchOption:"all",
    searchString:''
  });

  //게시글 목록 저장 변수
  const [varSuggestionLists,setSuggestionLists] = useState([]);
  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  //대기상태만 보기
  const [varViewWaiting,setViewWaiting] = useState(false);

  //게시판 정보 전체 가져오기
  const readSuggestionLists = () => {
    var sendData = {currentPage: varPageNum,pageSize: varPageSize,searchData: varSearchData,viewWaiting:varViewWaiting};
    console.log(sendData);
    axios.post(`${process.env.REACT_APP_HOST}/_get_suggestion_list`, sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      if (datas.retvalue === 1) {
        setTotalCount(datas.totalcount);
        const pmax = datas.totalcount - (varPageNum - 1) * varPageSize;
        const dataSet = datas.results.map((data, i) => ({
          board_idx: data.board_idx,
          board_num: pmax - i,
          quest_idx: data.quest_idx,
          quest_name: data.mem_id,
          quest_mode: data.mem_mode===1?"일반":data.mem_mode===2?"기사":data.mem_mode===3?"직원":":관리자",
          st_department: isNull(data.st_idx)?"":data.st_department,
          st_position: isNull(data.st_idx)?"":data.st_position,
          board_title: data.board_title,
          board_comment: data.board_comment,
          board_answer: data.board_answer,
          board_rdate: data.board_rdate,
          board_hits: data.board_hits,
          board_status: data.board_status,
          checked:false
        }));
        setSuggestionLists(dataSet);
      } else {
        setTotalCount(0);
        setSuggestionLists([]);
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    setMenuItem('SuggestionList');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //페이지가 바뀌면
  useEffect(() => {
    readSuggestionLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData,varViewWaiting]);

  //대기상태만 보기
  const onChangeViewWaitingHandler = (e) => {
    setViewWaiting(e.currentTarget.checked);
  }

  return  (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="게시판 관리" varPageTitle="건의 관리" />
      <div className="admin-content">
        <SuggestionSearch varTotalCount={varTotalCount} varSearchData={varSearchData} setSearchData={setSearchData}/>
        <SuggestionSearchResult varSuggestionLists={varSuggestionLists} setSuggestionLists={setSuggestionLists} readSuggestionLists={readSuggestionLists}
                              varViewWaiting={varViewWaiting} onChangeViewWaitingHandler={onChangeViewWaitingHandler}/>
        <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
      </div>
    </div>
  );
}


export default SuggestionList;
